import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchProjectList = createAsyncThunk("fetchProjectList", async ({ page, limit, filters }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		categoryId: filters?.categoryId ?? "",
		projectTypeId: filters?.projectTypeId ?? "",
		stageId: filters?.stageId ?? "",
	});

	const response = await axiosHttp.get(`leads/list?${params}`, config);
	return response.data.data;
});

const ProjectsListSlice = createSlice({
	name: "ProjectsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchProjectList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchProjectList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchProjectList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ProjectsListSlice.reducer;
